// @flow
import { getPlaceholder, getPrefix } from './data';
import transformByMask from './transformByMask';
import { type CountryCode } from './types';


const phoneTransforByCountryCode = (value: string, code: CountryCode = 'ru') => {
  const placeholder = getPlaceholder(code);
  const prefix = getPrefix(code);
  return transformByMask(value, placeholder, prefix);
};

export default phoneTransforByCountryCode;
